// extracted by mini-css-extract-plugin
module.exports = {"picker":"ColorPicker_picker__2RdNF","small":"ColorPicker_small__QWD1Q","active":"ColorPicker_active__4jfg2"};